import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.states';
import { Observable, of } from 'rxjs';
import { loadUserCredits } from '../store/actions/credits.actions';
import { loadPacks } from '../store/actions/packs.actions';
import { loadSubscriptionPlans } from '../store/actions/subscription-plans.actions';

export const profileGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const store = inject(Store<AppState>);
  const userId = JSON.parse(localStorage.getItem('user') || '{}').user_id;
  
  if (!userId) return of(false);
  
  store.dispatch(loadUserCredits({ userId: userId }));
  store.dispatch(loadPacks())
  store.dispatch(loadSubscriptionPlans())
  
  return of(true);
};